"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPayablesQuery = exports.PayoutStatusFilter = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
/**
 * Payout status filter values.
 * Use 'NONE' to filter for payables not in any payout.
 * Multiple values can be comma-separated: ?payoutStatus=NONE,DRAFT,PENDING_APPROVAL
 */
exports.PayoutStatusFilter = typebox_1.Type.String({
    description: "Comma-separated payout statuses. Use 'NONE' for payables not in any payout. Values: NONE, DRAFT, PENDING_APPROVAL, APPROVED, PROCESSING, COMPLETED, FAILED, CANCELLED",
});
exports.GetPayablesQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    haulerID: typebox_1.Type.String(),
    payoutID: typebox_1.Type.String(),
    /** Filter by payout status. Use 'NONE' for payables not in any payout. Comma-separated for multiple. */
    payoutStatus: exports.PayoutStatusFilter,
    readyForPayment: typebox_1.Type.Boolean(),
    void: typebox_1.Type.Boolean(),
    issuedBefore: typebox_1.Type.String(),
    issuedAfter: typebox_1.Type.String(),
    dueBefore: typebox_1.Type.String(),
    dueAfter: typebox_1.Type.String(),
    paidBefore: typebox_1.Type.String(),
    paidAfter: typebox_1.Type.String(),
    invoiceNumber: typebox_1.Type.String(),
    /** Partial match on invoice memo field (contains search). Useful for finding vendor invoice numbers stored in memo. */
    memo: typebox_1.Type.String(),
    orderID: typebox_1.Type.String(),
    serviceOrderID: typebox_1.Type.String(),
    serviceGroupingID: typebox_1.Type.String(),
    commercialSubscriptionID: typebox_1.Type.String(),
    referenceID: typebox_1.Type.String(),
    referenceType: common_1.EntityType,
    syncedWithAccounting: typebox_1.Type.Boolean(),
    paidInFull: typebox_1.Type.Boolean(),
    limit: typebox_1.Type.Number(),
    offset: typebox_1.Type.Number(),
    sortBy: typebox_1.Type.String(),
    sortDescending: typebox_1.Type.Boolean(),
}));
//# sourceMappingURL=get-payables-query.js.map